import React, { useContext, useEffect, useState } from 'react'
import './mainChat.css';
import Header from '../../header/Header';
import Sidebar from '../../sidebar/Sidebar';
import Chat from '../Chat';
import Drawer from '../../drawer/Drawer';

import getGlobalVarContext from "../../context/getGlobalVarContext";
import { useIntl } from 'react-intl';
import common from "../../config/common.json";

function MainChat() {
  const { globalVar } = useContext(getGlobalVarContext());
  const { data, renderView, pubnub, isRightSideBarOpen } = globalVar;
  const { subID } = globalVar;
  const [userProfile, setUserProfile] = useState("");
  const intl = useIntl()
  
  function profileUrl() {
    var requestOptions = {
      method: "GET"
    };
    fetch(`${common.BASEURL}/user/details?email=${localStorage.getItem("email")}`,requestOptions)
      .then((response) => response.text())
      .then(async (result) => {
        let data = JSON.parse(result);
        if (data.msg.profile_url) {
          setUserProfile(data.msg.profile_url);
          localStorage.setItem("profile_user", data.msg.profile_url);
        }
      })
      .catch((error) => { });
  }
  useEffect(() => {
    const script = document.createElement('script');
    profileUrl()
    script.src = intl.formatMessage({ id: "couponCodeIdea" })
    script.async = true;

    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="App">
      <div className='appbody'>
        {common.ClientId === "KONNECTUKRAINE" ?
        <div className="elfsight-app-e5837b68-074e-47ad-9bca-ce82b74c8c75">
        </div>:""}
        <div className='main_container' >
          <Header />
          <div className='sidebar_container' >
            <Sidebar />
            {renderView ? <Chat data={data} pubnub2={pubnub} /> : ""}
          </div>
        </div>
        { isRightSideBarOpen && <div className='drawer_container' >
          <Drawer />
        </div>}
      </div>
    </div>
  )
}

export default MainChat